module.exports = __webpack_public_path__ + "96da02b0a45d961a9978aad321878ab3.svg";